var React = require('react');

function Timer (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.25.75h-4.5v1.5h4.5V.75zm-3 9.75h1.5V6h-1.5v4.5zm6.023-4.957l1.065-1.066A8.286 8.286 0 0 0 12.28 3.42l-1.065 1.065A6.721 6.721 0 0 0 7 3a6.75 6.75 0 1 0 6.75 6.75c0-1.59-.555-3.053-1.477-4.207zM7 15a5.246 5.246 0 0 1-5.25-5.25A5.246 5.246 0 0 1 7 4.5a5.246 5.246 0 0 1 5.25 5.25A5.246 5.246 0 0 1 7 15z","fill":"currentColor","fillRule":"evenodd"}));
}

Timer.defaultProps = {"width":"14","height":"17","viewBox":"0 0 14 17"};

module.exports = Timer;

Timer.default = Timer;
